import AsyncMessageResponseHandler from "components/Shared/AsyncMessageResponseHandler"
import MetricSummaryCards from "components/Shared/Cards/MetricSummaryCards"
import SummaryCardSkeleton from "components/Shared/Cards/MetricSummaryCards/SummaryCardSkeleton"
import { MONTHLY_INTERVAL } from "components/Shared/Charts/Timeline/constant"
import withVisibility from "components/Shared/Hocs/withVisibility"
import SkeletonWrapper from "components/Shared/SkeletonWrapper"
import React from "react"
import { useIntl } from "react-intl"
import { SUMMARY_METRIC, day_format } from "../../constants"
import { BenchmarkPeriod, BenchmarkSummaryData } from "../../interfaces"
import { getMetricNameForInsight } from "../MetricsSelect/utils"
import { useGetSummaryBenchmark } from "../../hooks/useGetSummaryBenchmark"
import {
	mapResponseMetricSummary,
	translatePresetToRange,
} from "../../utils/utils"
import moment from "moment"
import { useFiltersContext } from "components/Shared/GlobalFilter/context/filtersContext"

interface SummaryCardsBenchmarkProps {
	filtersBenchmark: any
}

const SummaryCardsBenchmark: React.FC<SummaryCardsBenchmarkProps> = (props) => {
	const { filtersBenchmark } = props
	const intl = useIntl()
	const {
		moduleState: {
			transactional: {
				benchmark: { metric: selectedMetric },
			},
		},
	} = useFiltersContext()
	const metric = getMetricNameForInsight(
		filtersBenchmark.metricName,
		SUMMARY_METRIC
	)
	const { period: translatePeriod } = translatePresetToRange(filtersBenchmark)

	const isOrdered = () => {
		return (
			moment(filtersBenchmark.previousFrom, day_format) >
			moment(filtersBenchmark.currentFrom, day_format)
		)
	}

	const {
		summary: cardsData,
		isPendingRequest: isPendingRequestCards,
		isError: isErrorCards,
		error: cardsError,
		refetch: refetchSummaryCards,
	} = useGetSummaryBenchmark({
		...filtersBenchmark,
		metricName: metric,
		interval: MONTHLY_INTERVAL,
		period: translatePeriod,
		selectedMetric,
	})

	return (
		<div data-testid="benchmark-summary">
			<AsyncMessageResponseHandler
				hasData={Boolean(cardsData?.commercialBenchmarkSummary.data)}
				error={cardsError}
				isError={isErrorCards}
				isLoading={isPendingRequestCards}
				retry={refetchSummaryCards}
				className="benchmark-error-container"
			>
				<SkeletonWrapper
					skeleton={<SummaryCardSkeleton cardsAmount={4} />}
					isLoading={isPendingRequestCards}
				>
					<MetricSummaryCards
						metricSummaries={
							mapResponseMetricSummary(
								cardsData?.commercialBenchmarkSummary.data as Array<
									BenchmarkSummaryData
								>,
								cardsData?.commercialBenchmarkSummary
									.periods as BenchmarkPeriod,
								cardsData?.commercialBenchmarkSummary.metricName,
								intl,
								filtersBenchmark.period,
								isOrdered()
							)?.data
						}
					/>
				</SkeletonWrapper>
			</AsyncMessageResponseHandler>
		</div>
	)
}

export default withVisibility(SummaryCardsBenchmark)
